import axios from 'axios';
import Api from '../../../../services/Api';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL;

function buildJsonHeaders() {
  const headers = {
    'Content-Type': 'application/json',
    'apikey': process.env.VUE_APP_RTEK8DSR,
    'paraphrase': process.env.VUE_APP_BJ7DC3S,
  };

  if (store.state && store.state.token) {
    headers['Authorization'] = `Bearer ${store.state.token}`;
  }

  return headers;
}

const TukkiService = {
  /**
   * Crée un devis pour le parcours Tukki.
   * @param {object} devisData - Les données du devis.
   * @returns {Promise<object>} La réponse de l'API.
   */
  async createDevis(devisData) {
    const url = `${API_URL}tukki/devis/add`;
    const normalizedAgentCode = String(devisData.codeAgent || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');
    const body = {
      telephone: devisData.telephone,
      pays: devisData.pays,
      dateDepart: devisData.dateDepart,
      duree: devisData.duree,
      codeAgent: normalizedAgentCode,
      passagers: devisData.passagers,
      plateforme: 'Front-Tukki'
    };
    try {
      const response = await axios.post(url, body, { headers: buildJsonHeaders() });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du devis via TukkiService:", error.response || error);
      throw error;
    }
  },

  /**
   * Récupère les détails d'un contrat Tukki.
   * @param {string|object} params - Le numéro de devis ou un objet contenant le numeroDevis.
   * @returns {Promise<object>} Les détails du contrat.
   */
  async getContratDetails(params) {
    const url = `${API_URL}tukki/contrat/details`;
    const body = {};
    if (params) {
      body.numeroDevis = typeof params === 'object' ? params.numeroDevis : params;
    } else {
      throw new Error("Le numéro de devis est requis.");
    }
    
    try {
      const response = await axios.post(url, body, { headers: buildJsonHeaders() });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des détails du contrat Tukki:", error.response || error);
      throw error;
    }
  },

  async initiateWavePayment(data) {
    const url = `wave/create/session/`;
    const origin = 'https://assuraf.com';
    const payload = {
      amount: data.montant,
      currency: "XOF",
      client_reference: "ASS381"+"_"+data.numeroDevis.replace(/\//g, '_'),
      error_url: `${origin}/payment/tukki/failed`,
      success_url: `${origin}/payment/tukki/wave/?mdoi=${data.numeroDevis.replace(/\//g, '_')}`
    };
    try {
      const response = await Api().post(url, payload);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de l'initialisation du paiement Wave Tukki:", error.response || error);
      throw error;
    }
  },

  async payWithOrangeMoney(data) {
    const url = `orangemoney/onestep`;
    const payload = {
      primettc: data.montant,
      telephone_client: data.telephone,
      code_otp: data.otp,
      reference: data.numeroDevis
    };
    try {
      const response = await Api().post(url, payload);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du paiement Orange Money Tukki:", error.response || error);
      throw error;
    }
  },

  async validateAgent(codeAgent) {
    const normalizedAgentCode = String(codeAgent || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');
    const url = `${API_URL}tukki/agent/validate?codeAgent=${normalizedAgentCode}`;

    try {
      const response = await axios.get(url, { headers: buildJsonHeaders() });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la validation du code agent:", error.response || error);
      throw error;
    }
  }
};

export default TukkiService;
